<template>
  <div>
    <Modal
      title="游戏管理"
      width="700"
      v-model="modalstate"
      :transfer="false"
    >
      <lida-table
        :propscolumns="columns"
        :data="items"
        :sortStatus="false"
        :props-page-size="10"
      ></lida-table>
      <div slot="footer">
        <Button
          type="primary"
          @click="modalstate = !modalstate"
        >取消</Button>
        <Button
          type="error"
          @click="modifySiteGameTrigger"
        >修改</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import triggerColumns from "@/mixins/triggerColumns"
export default {
  name: 'ModalElectronicGame',
  mixins: [triggerColumns],
  props: {
    siteid: [String, Number],
  },
  data () {
    return {
      modalstate: false,
      sortSate: true,
      columns: {
        linkgameid: {
          title: '游戏编号',
          key: 'linkgameid',
          align: 'center',
          className: "infor-column",
        },
        gamename: {
          title: '游戏名称',
          key: 'gamename',
          align: 'center'
        },
        idop: {
          title: '开启/关闭',
          key: 'title',
          align: 'center',
          renderHeader: (this.triggerHeaderIdop),
          render: (h, params) => this.triggerIdop(h, params, 'linkgameid')
        }
      },
      items: []
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  watch: {
    modalstate (val) {
      // if (!val) return
      // this.getSiteGameTriggerList(this.siteid)
    }
  },
  methods: {
    trigger (companyid) {
      this.modalstate = true
      this.getSiteGameTriggerList(this.siteid, companyid)
    },
    async getSiteGameTriggerList (val, companyid) {
      try {
        const res = await this.$axios.cq9.getSiteGameTriggerList(val, companyid)
        if ('status' in res && res.status === 0) return
        this.items = res.map(it => {
          const nameset = it.nameset ? it.nameset.find(it => it.lang.toLowerCase() == 'zh-cn') : null
          it.idop = Number(it.idop)
          it.gamename = nameset ? nameset.name : null
          it.defaultidop = it.idop
          it.idopText = it.idop ? '开启' : '关闭'
          return it
        })
      } catch (error) {
        console.error(error);
        this.$Message.error('取得错误');
      }
    },
    async modifySiteGameTrigger () {
      const obj = {
        loid: this.getmember.pid,
        stid: this.siteid,
        gameitme: this.modifyArray(this.items, (it) => ({ linkgameid: it.linkgameid, idop: it.idop }))
      }
      if (!obj.gameitme.length) return this.$Message.warning("请选择修改游戏");
      try {
        const res = await this.$axios.cq9.modifySiteGameTrigger(obj)
        if (res.status === 1) {
          this.$Message.success("已更改");
          this.modalstate = false;
          this.items = []
        }
      } catch (error) {
        console.log(error);
        this.$Message.error('修改游戏开关错误');
      }
    }
  }
}
</script>